//export const BASE_URL = 'http://127.0.0.1:8000';
export const BASE_URL = 'https://bvuassociation.org/members/admin';

